import { themeConstants } from '@paywithextend/components'
import { cta_linkTextAlert } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .NotesInput {
    &-header {
      display: flex;
      align-items: center;
      gap: ${spacing(3)};
      margin-bottom: ${spacing(4)};
    }

    &-status {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: ${spacing(1)};

      &.saving {
        ${font_md};
        font-family: ${font_family_weight_medium};
        color: ${themeConstants.colors.highlight};
      }
      &.error {
        ${font_md};
        font-family: ${font_family_weight_medium};
        color: ${cta_linkTextAlert};
      }
      &.saved {
        display: flex;
        align-items: center;
        gap: ${spacing(1)};
        ${font_md};
        font-family: ${font_family_weight_medium};
        color: ${themeConstants.colors.highlight};
        @keyframes fadeOut {
          0%,
          75% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
        animation: fadeOut 5000ms;
      }
    }

    &-input {
      border-radius: ${spacing(2)};
    }
  }
`
